import { connect, MapStateToProps } from 'react-redux';
import { Props } from './SearchBar';
import { AppState } from '../../../../types/store';
import {
  getRelatedTags,
  getSearchQuery,
  getSelectedTags,
} from '../../../../selectors/page';
import { getTotal } from '../../../../selectors/stream';

export type StateProps = Pick<
  Props,
  'searchTerm' | 'estTotalTotal' | 'filterTags' | 'selectedTags'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  estTotalTotal: getTotal(state),
  filterTags: getRelatedTags(state),
  searchTerm: getSearchQuery(state) || '',
  selectedTags: getSelectedTags(state),
});

export default connect(mapStateToProps);
